import { useEditorStore } from '../store/editor-store';
import { GalleryBrowser, type GalleryItem } from './GalleryBrowser';

export function GalleryPanel({
  apiBase,
  storeId = 'ox',
  onPickArtwork,
}: {
  apiBase: string;
  storeId?: string;
  /** Place gallery art by catalog code (no Asset upload). */
  onPickArtwork: (item: GalleryItem) => Promise<void>;
}) {
  const setPanel = useEditorStore((s) => s.setPanel);
  const selectedId = useEditorStore((s) => s.selectedId);

  function closeGallery() {
    setPanel(selectedId ? 'design' : 'none');
  }

  return (
    <aside className="ox-side-panel ox-gallery-panel">
      <div className="ox-panel-head">
        <button type="button" className="ox-panel-back" onClick={closeGallery}>
          ←
        </button>
        <h3>Galería</h3>
        <button type="button" className="ox-panel-close" onClick={closeGallery} aria-label="Cerrar">
          ✕
        </button>
      </div>
      <GalleryBrowser apiBase={apiBase} storeId={storeId} onPickArtwork={onPickArtwork} />
    </aside>
  );
}
